module.exports = __webpack_public_path__ + "media/images/workshop_benefits-cae2c117cad33b6bcc880cbb06fe562c.jpeg";